<p class="snack-label" matSnackBarLabel>
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ data.message }}</span>
</p>
@if (data.action) {
  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      {{ data.action | translate }}
    </button>
  </span>
}
